<template>
    <!--新增、查看、修改功能模板-->
    <el-dialog class="haveTable" :title="title" :fullscreen="true" append-to-body :close-on-click-modal="false"
               :visible.sync="visible" v-if="visible">
        <el-tabs v-model="activeTab" @tab-click="selTab">
            <el-tab-pane :label="item.associationMetadataBasicDataName" :name="item.id" v-for="(item, index) in tabList" :key="index"></el-tab-pane>
        </el-tabs>
        <div class="mainBox" v-loading="loading" v-show="mainTab">
            <AddEditFormItem ref="addEditFormItem" refName="addEditFormItem" :list="fieldList" :allFieldList="fieldList"
                             :form="form"
                             :allForm="form" :method="method" :configId="configId" :basicDataId="basicDataId"
                             :metadataBasicDataRuleVoList="metadataBasicDataRuleVoList"
                             :metadataBasicDataShowRuleVo="metadataBasicDataShowRuleVo"
                             :metadataBasicDataRangeRuleVo="metadataBasicDataRangeRuleVo" @refreshData="refreshData"
                             :attachmentList="attachmentList"></AddEditFormItem>
            <!--子表单、子模板-->
            <el-collapse v-model="activeNames" v-if="formList.length" @change="collapseChange">
                <el-collapse-item :title="item.basicRename" :name="item.basicCode" v-for="(item, index) in formList"
                                  :key="index">
                    <!--子表单-->
                    <div v-if="item.basicAssemblyId == '19'">
                        <div class="p_l1">
                            <el-button type="primary" size="small" icon="el-icon-plus" v-if="method != 'view'"
                                       @click="addEidtSubform(null, 'add', item)">新增
                            </el-button>
                            <el-button size="small" @click="importData(item)" v-if="method != 'view'">
                                <i class="icon-piliangdaoru iconfont buIcon"/>批量导入
                            </el-button>
                            <el-button size="small" @click="exportData(item)" v-if="method == 'edit'">
                                <i class="icon-piliangdaochu iconfont buIcon"/>批量导出
                            </el-button>
                            <el-button size="small" @click="downloadSubform(item)" v-if="method == 'edit'">
                                <i class="icon-piliangdaochu iconfont buIcon"/>批量下载
                            </el-button>
                            <el-button type="danger" size="small" icon="el-icon-delete" v-if="method != 'view'"
                                       @click="delSubform(item)">批量删除
                            </el-button>
                        </div>
                        <el-table :data="form[item.basicCode]" :ref="item.basicCode"
                                  @selection-change="selectionChangeHandle($event, item)" size="small" max-height="300"
                                  class="table m_t1" border>
                            <el-table-column fixed type="selection"></el-table-column>
                            <el-table-column v-for="(v, i) in item.children" :key="i" :prop="v.basicCode"
                                             :label="v.basicRename" show-overflow-tooltip
                                             v-if="v.basicAssemblyId != 3 && v.basicAssemblyId != 13 && v.basicAssemblyId != 14 && v.basicAssemblyId != 15 && v.basicAssemblyId != 16 && v.basicAssemblyId != 17 && v.basicAssemblyId != 18">
                                <template slot-scope="scope">
                                    <span>{{listDataFormat(v, scope.row[v.basicCode])}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" width="160">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small"
                                               @click="addEidtSubform(scope.row, 'view', item)">详情
                                    </el-button>
                                    <el-button type="text" size="small" v-if="method != 'view'"
                                               @click="addEidtSubform(scope.row, 'edit', item)">修改
                                    </el-button>
                                    <el-button type="text" size="small" v-if="method == 'edit'"
                                               @click="downloadSubform(item, scope.row)">下载
                                    </el-button>
                                    <el-button type="text" size="small" v-if="method != 'view'"
                                               @click="delSubform(item, scope.$index)">删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <!--子模板-->
                    <div v-if="item.basicAssemblyId == '20'">
                        <AddEditFormItem :ref="`ref${item.basicCode}`" :refName="item.basicCode" :list="item.children"
                                         :allFieldList="fieldList"
                                         :form="form[item.basicCode]" :allForm="form"
                                         :moduleType="20" :method="method" :configId="configId"
                                         :basicDataId="basicDataId"
                                         :metadataBasicDataRuleVoList="metadataBasicDataRuleVoList"
                                         :metadataBasicDataShowRuleVo="metadataBasicDataShowRuleVo"
                                         :metadataBasicDataRangeRuleVo="metadataBasicDataRangeRuleVo"></AddEditFormItem>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div v-if="!mainTab">
            <el-table
                    :data="associationList"
                    size="small" height="100%"
                    class="table" ref="multipleTable" border
                    @selection-change="selectionChangeHandle" @sort-change="sortChange" row-key='id'
                    v-loading="loading">
                <el-table-column type="selection" :reserve-selection='true' fixed/>
                <el-table-column v-for="(item, index) in associationField" :key="index"
                                 :prop="item.basicCode"
                                 :label="item.basicRename"
                                 :sortable="item.basicAssemblyId == '8' || item.basicAssemblyId == '9' || item.basicAssemblyId == '12' ? 'custom' : false"
                                 show-overflow-tooltip min-width="100">
                    <template slot-scope="scope">
                        <span>{{listDataFormat(item, scope.row.jsonData[item.basicCode])}}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="{row}">
                        <el-button type="text" size="small"
                                   @click="associationView(row, 'view')">详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                        @pagination="getAssociationList"/>
        </div>
        <div slot="footer">
            <el-button size="small" @click="visible = false">{{method == 'view' ? '关闭':'取消'}}</el-button>
            <el-button type="primary" size="small" :icon="item.detailIcon" :disabled="loading" v-if="method != 'view' && item.meetConditions" v-for="(item, index) in fromFonctionsList" :key="index" @click="operateBtn(item)" v-noMoreClick>{{item.detailName}}</el-button>
            <el-button v-if="hasPermission('converge:mark:markIndex:through')" v-show="selectList.labeState == 1 && pageType == 'markIndex'" type="primary" @click="setToexamine('','through')" size="small">通过</el-button>
            <el-button v-if="hasPermission('converge:mark:markIndex:reject')" v-show="selectList.labeState == 1 && pageType == 'markIndex'" @click="setToexamine('','reject')" size="small">驳回</el-button>
        </div>
        <AddEidtSubform ref="addEidtSubform"></AddEidtSubform>
        <ImportData ref="importData" @refreshData="getSubform"></ImportData>
        <ExportData ref="exportData"></ExportData>
        <set-toexamine ref="setToexamine" @refresh="refreshData(1,1)"></set-toexamine>
        <!--关联模板数据查看-->
        <ResourceAddEditForm ref="resourceAddEditForm"></ResourceAddEditForm>
    </el-dialog>
</template>

<script>
    import AddEditFormItem from "./AddEditFormItem";
    import AddEidtSubform from "./AddEidtSubform";
    import ImportData from '@/components/importData/importData'  // 导入弹窗
    import ExportData from '@/components/exportData/exportData'  // 导出弹窗
    import SetToexamine from "@/components/toExamine/setToexamine.vue";  // 导出弹窗

    export default {
        components: {AddEditFormItem, AddEidtSubform, ImportData, ExportData, SetToexamine},
        data() {
            return {
                visible: false,
                loading: false,
                method: '',
                title: '',
                configId: '',
                basicDataId: '',
                activeNames: [],
                fieldList: [],
                formList: [],
                id: '',
                form: {},
                fromFonctionsList: [],
                importBasicCode: '',
                attachmentList: [],  // 固定附件列表
                associatedItem: [], // 关联数据
                subTemplateFlag: false,  // 子模板数据回显标志
                metadataBasicDataRuleVoList: [], // 数据规则集合
                metadataBasicDataShowRuleVo: [], // 隐显规则集合
                metadataBasicDataRangeRuleVo: [], // 值域规则集合
                // 通过驳回所需参数
                selectList:{},
                pageType:'',
                routeInfo: {}, // 当前路由信息
                curTemplate: {}, // 当前主模板信息
                activeTab: '', // 当前tab
                tabList: [],
                associationField: [], //当前关联模板字段
                associationList: [],
                searchForm: {
                    keyword: '',
                    basicDataId: '',
                    current: 1,
                    size: 20,
                    whereList: [],
                    sortArchivesDataElasticsearch: [],
                    tableFonctionsList: [],
                },
                total: 0,
                mainTab: true,
            }
        },
        methods: {
            init(method, id, configId, basicDataId, fromFonctionsList, selectList, pageType) {
                let dynamicMenuRoutes = JSON.parse(sessionStorage.getItem('dynamicMenuRoutes') || '[]')
                this.routeInfo = dynamicMenuRoutes.filter(item => item.fullPath === this.$route.fullPath)[0]
                this.selectList = selectList || {}
                this.pageType = pageType || ''
                this.subTemplateFlag = false
                this.mainTab = true
                this.curTemplate = {}
                this.tabList = []
                this.activeTab = ''
                this.metadataBasicDataRuleVoList = []
                this.metadataBasicDataShowRuleVo = []
                this.metadataBasicDataRangeRuleVo = []
                this.associatedItem = []
                this.activeNames = []
                this.fieldList = []
                this.formList = []
                this.form = {}
                this.method = method
                this.configId = configId || ''
                this.basicDataId = basicDataId || ''
                this.id = id ? id : ''
                if (method === 'add') {
                    this.title = `新增`
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                this.visible = true
                this.$nextTick(() => {
                    this.getFromFonctionsList()
                    this.getFields()
                })
            },
            // 选择tab
            selTab(val) {
                let data = this.tabList.filter(v => v.id == val.name)[0]
                if(!data.mainTab) {
                    this.mainTab = false
                    this.loading = true
                    this.getAssociationField(data)
                } else {
                    this.mainTab = true
                }
            },
            // 获取关联模板字段
            getAssociationField(data) {
                data.whereList.map(v => {
                    const index = v.key.indexOf('.');
                    if (index!== -1) {
                        let key = v.key.slice(index + 1).trim();
                        this.$set(v, 'key', key)
                    }
                })
                this.searchForm.basicDataId = data.associationMetadataBasicDataId
                this.searchForm.whereList = data.whereList
                this.$axios(this.api.metadata.getTableAndWhere, {basicDataId: data.associationMetadataBasicDataId}).then(data => {
                    if (data.status) {
                        this.associationField = data.data
                        this.getAssociationList()
                    } else {
                        this.loading = false
                    }
                })
            },
            // 获取关联模板列表数据
            getAssociationList() {
                this.$axios(this.api.metadata.queryElasticsearchTemplatePageHome, this.searchForm, 'post').then(data => {
                    if (data.status) {
                        this.associationList = data.data.records
                        if (this.associationList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.getAssociationList()
                        }
                        this.total = parseInt(data.data.total)
                    } else {
                        this.$message.error('查询失败');
                    }
                    this.loading = false
                })
            },
            // 关联模板查看
            associationView(row, type) {
                this.$refs.resourceAddEditForm.init(type, row.id, '', this.searchForm.basicDataId)
            },
            // 获取字段
            getFields() {
                this.loading = true
                this.$axios(this.api.metadata.selectTreeMetadataBasicDataById, {basicDataId: this.basicDataId}, 'get').then(data => {
                    if (data.status) {
                        this.fieldList = data.data.children
                        this.metadataBasicDataShowRuleVo = data.data.metadataBasicDataShowRuleVo
                        this.metadataBasicDataRangeRuleVo = data.data.metadataBasicDataRangeRuleVo
                        this.fieldList.map(item => {
                            if (item.basicAssemblyId == '19' || item.basicAssemblyId == '20') {
                                this.formList.push(item)
                            }
                            if (item.basicForAddRang == '0') {
                                this.$set(item, 'basicForAddRangVal', '')
                                this.$set(item, 'basicForAddRangFlag', false)
                            }
                        })
                        this.recursion(this.fieldList, this.form)
                        if (this.method != 'add') {
                            this.getInfo()
                        } else {
                            this.fromBtnMeetConditions()
                            this.loading = false
                        }
                    } else {
                        this.$message.error('查询失败')
                    }
                })
            },
            // 获取详情信息
            getInfo() {
                this.$axios(this.api.metadata.metadatadataGetById + '/' + this.id).then(data => {
                    if (data.status) {
                        this.form = this.recover(this.form, data.data.jsonData);
                        this.attachmentList = data.data.metadataAttachments;
                        if(data.data.metadataBasicDataAssociationList.length) {
                            this.tabList.push(this.curTemplate)
                            this.activeTab = this.curTemplate.id
                            this.tabList = this.tabList.concat(data.data.metadataBasicDataAssociationList)
                        }
                        this.fromBtnMeetConditions()
                        if (!this.associatedItem.length) {
                            this.loading = false
                            return
                        }
                        this.associatedItem.map(item => {
                            if (this.form[item.basicCode].length) {
                                this.getAssociated(item.metadataBasicDataRuleVo.associationBasicDataId, this.form[item.basicCode], item)
                            } else {
                                this.loading = false
                            }
                        })
                    }
                })
            },
            // 获取表单按钮
            getFromFonctionsList() {
                this.$axios(this.api.metadata.metadatatableconfigGetById + '?configId=' + this.configId + '&metadataFonctionsModelId=', [], 'post').then(data => {
                    if (data.status && data.data) {
                        let val = data.data.basicDataIdList.filter(v => v.basicDataId == this.basicDataId)
                        if(val.length) {
                            this.curTemplate = val[0]
                            this.fromFonctionsList = this.curTemplate.fromFonctionsList
                            this.fromFonctionsList.map(item => {
                                this.$set(item, 'meetConditions', true)
                            })
                            this.curTemplate.associationMetadataBasicDataName = this.curTemplate.basicDataName
                            this.curTemplate.mainTab = true
                        }

                    }
                })
            },
            // 获取关联数据
            getAssociated(configId, ids, item) {
                this.$axios(this.api.metadata.groupByTemplate + "?configId=" + configId, ids, 'post').then(data => {
                    if (data.status) {
                        this.$set(item, 'basicDataIdList', data.data.basicDataIdList)
                    }
                    this.loading = false
                })
            },
            // 递归
            recursion(list, form) {
                list.map(item => {
                    if (!item.basicCode) {
                        return
                    }
                    if (this.metadataBasicDataShowRuleVo && this.metadataBasicDataShowRuleVo.filter(v => v.basicCode == item.basicCode).length > 0) {
                        this.$set(item, 'showRuleFlag', false)
                    } else {
                        this.$set(item, 'showRuleFlag', true)
                    }
                    if (item.basicAssemblyId == 16) {
                        this.$set(item, 'associatedBasicDataId', 0)
                        if (item.metadataBasicDataRuleVo && item.metadataBasicDataRuleVo.associationBasicDataId) {
                            this.associatedItem.push(item)
                        }
                    }
                    if (item.basicAssemblyId == 6 || item.basicAssemblyId == 7 || item.basicAssemblyId == 13 || item.basicAssemblyId == 14 || item.basicAssemblyId == 15 || item.basicAssemblyId == 16 || item.basicAssemblyId == 17 || item.basicAssemblyId == 19) {
                        this.$set(form, item.basicCode, [])
                    } else if (item.basicAssemblyId == 20) {
                        this.$set(form, item.basicCode, {})
                    } else {
                        if (item.metadataBasicDataRuleVo && item.metadataBasicDataRuleVo.ruleDefaultValue) {
                            this.$set(form, item.basicCode, item.metadataBasicDataRuleVo.ruleDefaultValue)
                        } else {
                            this.$set(form, item.basicCode, null)
                        }
                    }
                    if (item.metadataBasicDataRuleVo) {
                        this.$set(item.metadataBasicDataRuleVo, 'basicCode', item.basicCode)
                        this.metadataBasicDataRuleVoList.push(item.metadataBasicDataRuleVo)
                    }
                    if (item.children.length && item.basicAssemblyId == 20) {
                        this.recursion(item.children, this.form[item.basicCode])
                    }
                    if (item.children.length && item.basicAssemblyId == 18) {
                        this.recursion(item.children, this.form)
                    }
                })
            },
            // 多选
            selectionChangeHandle(val, item) {
                this.$set(item, 'dataListSelections', val)
            },
            // 删除子表单数据
            delSubform(item, index) {
                let list = this.form[item.basicCode]
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (index || index == 0) {
                        list.splice(index, 1);
                    } else {
                        list = list.filter(v => !item.dataListSelections.includes(v))
                        this.$set(this.form, item.basicCode, list)
                        this.$set(item, 'dataListSelections', [])
                    }
                    this.$message.success('删除成功')
                })
            },
            // 新增子表单
            addEidtSubform(row, method, item, configId, basicDataId) {
                this.$refs.addEidtSubform.init(row, method, item, this.form, configId, basicDataId)
            },
            // 获取子表单数据
            getSubform(data) {
                if (data && data.length) {
                    data.map(item => {
                        this.form[this.importBasicCode].push(item.jsonData)
                    })
                }
            },
            // 子表单下载
            downloadSubform(item, row) {
                if ((!row && !item.dataListSelections) || (!row && !item.dataListSelections.length)) {
                    this.$message.warning('请选择需要下载的数据！')
                    return
                }
                let dataId = []
                if (row) {
                    dataId = [row.id]
                } else {
                    dataId = item.dataListSelections.map(item => {
                        return item.id
                    })
                }
                this.fileBlobDownload(this.api.metadata.downloadItemFile, {
                    basicCode: item.basicCode,
                    basicDataId: item.associationBasicDataId,
                    configId: this.configId,
                    dataId,
                    id: this.id || '',
                }, '下载文件', 'application/zip')
            },
            // 子表单批量导入
            importData(item) {
                this.importBasicCode = item.basicCode
                let tableList = item.children.filter(v => v.basicAssemblyId != 3 && v.basicAssemblyId != 13 && v.basicAssemblyId != 14 && v.basicAssemblyId != 15 && v.basicAssemblyId != 16 && v.basicAssemblyId != 17 && v.basicAssemblyId != 18)
                this.$refs.importData.init(this.configId, item.associationBasicDataId, tableList)
            },
            // 子表单批量导出
            exportData(item) {
                if (!this.form[item.basicCode].length) {
                    this.$message.warning('暂无可导出的数据！')
                    return
                }
                let idList = []
                if (item.dataListSelections && item.dataListSelections.length) {
                    idList = item.dataListSelections.map(item => {
                        return item.id
                    })
                }
                this.$nextTick(() => {
                    let api = this.api.metadata.ItemBatchExport
                    this.$refs.exportData.init(this.configId, item.associationBasicDataId, idList, item.basicRename, null, api, 'subForm', {
                        id: this.id,
                        basicCode: item.basicCode
                    })
                })
            },
            // 按钮条件匹配
            fromBtnMeetConditions() {
                this.fromFonctionsList.map(item => {
                    let conformNum = 0, andNum = 0
                    item.metadataTableConfigPageWhereList.map(v => {
                        let rangeLen = 0
                        let val = this.form[v.basicCode]
                        v.whereDetailName.map(r => {
                            if(Array.isArray(this.form[v.basicCode])) {
                                rangeLen = this.form[v.basicCode].filter(val => val == r).length
                            }
                            if(!Array.isArray(this.form[v.basicCode]) && this.form[v.basicCode] == r) {
                                rangeLen++
                            }
                            if (v.conditionApproach == 'and') {
                                if ((v.condition == '%' && rangeLen > 0) || (v.condition == '!%' && rangeLen == 0) || (v.condition == '=' && val == r) || (v.condition == '!=' && val != r) || (v.condition == '=null' && !val) || (v.condition == '!=null' && val)) {
                                    andNum++
                                }
                                if (andNum == item.metadataTableConfigPageWhereList.length) {
                                    conformNum++
                                }
                            } else {
                                if ((v.condition == '%' && rangeLen > 0) || (v.condition == '!%' && rangeLen == 0) || (v.condition == '=' && val == r) || (v.condition == '!=' && val != r) || (v.condition == '=null' && !val) || (v.condition == '!=null' && val)) {
                                    conformNum++
                                }
                            }
                        })
                    })
                    this.$nextTick(() => {
                        if(conformNum > 0) {
                            this.$set(item, 'meetConditions', false)
                        }
                    })
                })
            },
            // 配置按钮
            operateBtn(item) {
                if (item.fonctionsNumber == 'form:submit') {
                    this.doSubmit(item.metadataFonctionsModelDetailId)
                } else {
                    const h = this.$createElement;
                    this.$msgbox({
                        title: '提示',
                        message: h('p', null, [
                            h('p', {style: 'color: #333333; margin-bottom: 5px'}, `确认${item.detailName}所选资源?`),
                        ]),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                    }).then(() => {
                        this.loading = true
                        this.$axios(this.api.metadata.batchUpdateDataByFonctionsModel, {
                            ids: [this.id],
                            metadataFonctionsModelDetailId: item.metadataFonctionsModelDetailId,
                            menuId: this.routeInfo.meta.menuId,
                            configId: this.configId,
                        }, 'post').then(data => {
                            if (data.status) {
                                this.$message.success('操作成功')
                                this.$emit('refreshData')
                                this.visible = false
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false

                        })
                    })

                }
            },
            // 提交
            doSubmit(metadataFonctionsModelDetailId) {
                let item = this.fieldList.filter(v => v.basicAssemblyId == '20')
                // 判断是否有子表单，校验子表单通过后提交数据
                if (item.length) {
                    let flag = this.$refs[`ref${item[0].basicCode}`][0].doSubmit(20)
                    if (flag) {
                        this.$refs.addEditFormItem.doSubmit(1, this.basicDataId, this.id, metadataFonctionsModelDetailId)
                    }
                } else {
                    this.$refs.addEditFormItem.doSubmit(1, this.basicDataId, this.id, metadataFonctionsModelDetailId)
                }
            },
            refreshData() {
                this.visible = false
                this.$emit('refreshData')
            },
            // 初始化子模板数据
            collapseChange(val) {
                let list = this.formList.filter(v => val.some(c => v.basicCode == c && v.basicAssemblyId == '20'))
                if (!this.subTemplateFlag && list.length) {
                    this.subTemplateFlag = true
                    let item = list[0]
                    this.$refs[`ref${item.basicCode}`][0].fileEcho(item.children)
                }
            },
            // 列表排序
            sortChange(column) {
                /*let item = this.basicDataInfo.whereList.filter(v => v.basicCode == column.prop)[0]
                this.searchForm.sortArchivesDataElasticsearch = [
                    {
                        assemblyType: item.assemblyType,
                        key: column.prop,
                        sort: column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : ''),
                    }
                ]*/
                this.getAssociationList()
            },
            //type through通过 reject驳回
            setToexamine(row, type) {
                let ids = [this.selectList.id]
                let url = this.api.academic.resourceslabelAudit
                if (type == 'through') {
                    //通过
                    this.$refs.setToexamine.init(ids, type, url, {
                        auditState: 2
                    })
                } else {
                    //驳回
                    this.$refs.setToexamine.init(ids, type, url, {
                        auditState: 3
                    })
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .mainBox {
        height: 100%;
    }

    .mainBox::v-deep .el-collapse-item__header {
        font-size: 14px !important;
        font-weight: 600 !important;
        background: #eee;
        padding-left: 20px;
    }

    .mainBox::v-deep .el-collapse-item__wrap {
        padding-top: 20px !important;
    }
</style>
